import PropTypes from "prop-types";
import {FaCheck, FaHome, FaSign, FaTimes, FaTruckMoving, FaUmbrellaBeach} from "react-icons/fa";

export default function property(props) {
    return {
        name: "property",
        title: 'Property',
        link: `apply/property`,
        personalisedTitle: 'The property details',
        props: props,
        questions: props.mortgage.mortgageType === "PURCHASE" ? [
            intendedUse(props),
            addressKnown(props),
            propertyType(props),
            address(props),
            newlyBuilt(props),
            purchasePrice(props),
            spendAmount(props),
            bedrooms(props),
            bathrooms(props),
            monthlyRent(props),
            adultsBoarding(props),
            adultsBoardingCount(props)
        ] : [
            residingHere(props),
            address(props),
            propertyType(props),
            yearOfPurchase(props),
            //TODO: Add Question, What was the original purchase price?
            purchasePrice(props),
            propertyValue(props),
            adultsBoarding(props),
            adultsBoardingCount(props)
        ]
    }
}

export function intendedUse(props) {
    return {
        label: "Mortgage Purpose",
        text: "What is the purpose of the new property?",
        name: "intendedUse",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Buying First Time",
                    value: "FIRSTTIME",
                    icon: <FaHome/>
                },
                {
                    text: "Moving House",
                    value: "MOVING",
                    icon: <FaTruckMoving/>
                },
                {
                    text: "Buying to Let",
                    value: "BUYTOLET",
                    icon: <FaSign/>
                },
                {
                    text: "Buying 2nd Home",
                    value: "HOLIDAYHOME",
                    icon: <FaUmbrellaBeach/>
                },

            ]
        },
        model: "property"
    }
}
export function adultsBoarding(props) {
    return {
        name: "adultsBoarding",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Other Adults Residing",
        text: "Will there be any other person over 17 who will occupy the property?",
        model: "property"
    }
}
export function adultsBoardingCount(props) {
    return {
        name: "adultsBoardingCount",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 10, message: "10 is the maximum here"}
            }
        },
        hides:{
            adultsBoarding: (v)=>{return v!==true}
        },
        label: "How Many Adults",
        text: "How many adults over the age of 17 will occupy the property?",
        model: "property"
    }
}
export function addressKnown(props) {
    return {
        label: "Property Found",
        text: "Have you found a property?",
        name: "addressKnown",
        answer: {
            type: "choice",
            choices: [
                {
                    value: true,
                    text: "Yes",
                    icon: <FaCheck size={23}/>
                }
                ,
                {
                    value: false,
                    text: "No",
                    icon: <FaTimes size={23}/>
                }
            ]
        },
        model: "property"
    }
}
export function propertyType(props) {
    const object = {
        label: "Property Type",
        text: "What type of property is this?",
        name: "propertyType",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Detached",
                    value: "DETACHED"
                },
                {
                    text: "Semi-detached",
                    value: "SEMIDETACHED"
                },
                {
                    text: "Terrace",
                    value: "TERRACE"
                },
                {
                    text: "Apartment",
                    value: "APARTMENT"
                },
                {
                    text: "Flat",
                    value: "FLAT"
                }
            ]
        },
        model: "property"
    }
    if (props.mortgage.mortgageType === "PURCHASE") {
        object.hides = {
            addressKnown: (v) => {
                return v !== true
            }
        }
    }
    return object
}
export function address(props) {
    const object = {
        label: "Property Address",
        text: "What is the address of the property?",
        name: "address",
        answer: {
            type: "address"
        },
        model: "property"
    }
    if (props.mortgage.mortgageType === "PURCHASE") {
        object.hides = {
            addressKnown: (v) => {
                return v !== true
            }
        }
    }
    return object
}
export function newlyBuilt(props) {
    return {
        label: "Property Build",
        text: {
            addressKnown: {
                false: "What type of property are you considering buying?",
                true: "What type of property are you buying?",
            }
        },
        name: "newlyBuilt",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Newly Built",
                    value: true
                },
                {
                    text: "Second Hand",
                    value: false
                }
            ]
        },
        model: "property"
    }
}
export function purchasePrice(props) {
    const q = {
        label: "Purchase price",
        text: props.mortgage.mortgageType==="REFINANCE" ? "What was the original purchase price of the property?" : "What is the purchase price of the property?",
        name: "purchasePrice",
        answer: {
            type: "euro",
            validation: {
                min: {value: 50000, message: "The minimum value here is €50,000"},
                max: {value: 1000000, message: "The maximum value here is €1,000,000"}
            }
        },
        model: "property"
    }
    if (props.mortgage.mortgageType === 'PURCHASE'){
        q.hides = {
            addressKnown: (v)=>{return v===false}
        }
    }
    return q
}
export function spendAmount(props) {
    return {
        label: "Spend amount",
        text: "How much are you prepared to spend on a property?",
        name: "spendAmount",
        answer: {
            type: "euro",
            validation: {
                min: {value: 50000, message: "The minimum value here is €50,000"},
                max: {value: 1000000, message: "The maximum value here is €1,000,000"}
            }
        },
        hides:{
            addressKnown: (v)=>{return v===true}
        },
        model: "property"
    }
}
export function bathrooms(props) {
    const object = {
        label: "Bathrooms",
        text: "How many bathroom has the property?",
        name: "bathrooms",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 10, message: "10 is the maximum here"}
            }
        },
        model: "property"
    }
    if (props.mortgage.mortgageType === "PURCHASE") {
        object.hides = {
            addressKnown: (v) => {
                return v !== true
            }
        }
    }
    return object
}
export function bedrooms(props) {
    const object = {
        label: "Bedrooms",
        text: "How many bedrooms has the property?",
        name: "bedrooms",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 10, message: "10 is the maximum here"}
            }
        },
        model: "property"
    }
    if (props.mortgage.mortgageType === "PURCHASE") {
        object.hides = {
            addressKnown: (v) => {
                return v !== true
            }
        }
    }
    return object
}
export function monthlyRent(props) {
    return {
        label: "Expected Rent",
        text: "What is the expected monthly rental income?",
        name: "monthlyRent",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            addressKnown: (v) => {
                return v !== true
            },
            intendedUse: (v) => {
                return v !== "BUYTOLET"
            }
        },
        model: "property"
    }
}

export function residingHere(props) {
    return {
        text: `Is this the property in which you currently reside?`,
        name: "residingHere",
        label: "Residing Here",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        model: "property"
    }
}
export function yearOfPurchase(props) {
    return {
        text: "In what year was this purchased?",
        name: "yearOfPurchase",
        label: "Year of Purchase",
        answer: {
            type: "year"
        },
        model: "property"
    }
}
export function propertyValue(props) {
    return {
        text: "What is the current value of the property",
        name: "propertyValue",
        label: "Property Value",
        answer: {
            type: "euro",
            validation: {
                min: {value: 90000, message: "The minimum value here is €90,000"},
                max: {value: 1000000, message: "The maximum value here is €1,000,000"}
            },
            step: 1000
        },
        model: "property"
    }
}
property.propTypes = {
    mortgageType: PropTypes.oneOf(["PURCHASE", "REFINANCE"])
};